import { render, staticRenderFns } from "./RegistrationConfirm.vue?vue&type=template&id=56d1f730&scoped=true&"
import script from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
export * from "./RegistrationConfirm.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationConfirm.vue?vue&type=style&index=0&id=56d1f730&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1f730",
  null
  
)

export default component.exports